var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CardBodyItem",
    {
      attrs: {
        label: "Contractors",
        customAlign: _vm.alignment,
        labelDivClass: "labelDivWidth self-start mt-1 items-center",
        itemExtraInfo: _vm.projectContractors.length,
      },
    },
    [
      _c("ContractorChips", {
        attrs: {
          contractors: _vm.projectContractors,
          navigateTo: {
            name: _vm.routeNames.PROJECT_ACTIVITY,
            params: { id: _vm.projectId },
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }